import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { create } from 'kts-scaffold-framework/utils/form';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import { Radio } from 'antd';
import Icon from 'src/display/components/Icon';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    /**
     * 回退功能
     */
    private onClickBackHandler = () => {
        this.props.history.goBack();
    }
    private tabsChange = (e) => {
        this.modulesState.openTabVisible = e.target.value;
        this.setModulesState();
    }
    render() {

        return (
            <div className={css.setPowerHeader}>
                {/* <div className={css.title}>
                    <div>选择人员</div>
                    <div className={css.buttList} >
                        <a onClick={this.onClickBackHandler} >
                            <Icon width={18} height={18} color="#060001" src={require('./Icon/img.close.svg')} />
                        </a>
                    </div>
                </div>
                 */}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.SetPower/UI.Head.tsx